/**
 * A percentage a bar can actually draw.
 *
 * Every progress bar in this app writes the same number into two places — `inline-size` and
 * `aria-valuenow` — so a figure outside 0–100 is not a cosmetic problem: it is a CSS length the
 * browser resolves to a negative track and a value a screen reader reads out as such. The wire
 * offers both ends of that. `weeksDone` can exceed `weeksTotal` on a plan the client outran, and it
 * can arrive negative from a plan whose start date moved forward under an already-counted week.
 *
 * Promoted out of `pages/client-detail/model/summaryColumn` on 2 September 2026, when the roster's
 * preview panel was found clamping only the top end: the same plan card said 100% on the detail and
 * -12% on the panel. One clamp, one rule, one place to change it.
 *
 * `null` in, `null` out, and `NaN` reads as `null` rather than as a number — an unmeasured quantity
 * is a card that says "no data", never a bar drawn at nothing.
 */
export function clampPercent(value: number | null | undefined): number | null {
  if (value == null || Number.isNaN(value)) return null;
  return Math.max(0, Math.min(100, Math.round(value)));
}
